import React, { Suspense } from 'react';

import { useModal } from 'context/ModalContext';
import ReactDOM from 'react-dom';
import { lazyWithRetry } from 'shared/lib/lazyRetry';

// 모달은 열릴 때만 렌더되므로 코드도 열릴 때 내려받는다 — 로그인 트리가 엔트리 번들에서 빠짐
const FindEmailModal = lazyWithRetry(() => import('pages/login/FindEmailModal'));
const LoginModal = lazyWithRetry(() => import('pages/login/LoginModal'));
const PasswordModal = lazyWithRetry(() => import('pages/login/PasswordModal'));
const ResetModal = lazyWithRetry(() => import('pages/login/ResetModal'));
const SignupModal = lazyWithRetry(() => import('pages/login/SignupModal'));

const Modals = () => {
  const { modalType, closeModal, closeModalWithRedirectClear, MODAL_TYPES } = useModal();

  if (modalType === MODAL_TYPES.NONE) return null;

  // 로그인 모달은 redirect 까지 같이 정리해야 해서 closeModalWithRedirectClear 사용
  const handleBackdropClose = () => {
    if (modalType === MODAL_TYPES.LOGIN) {
      closeModalWithRedirectClear();
    } else {
      closeModal();
    }
  };

  const renderModal = () => {
    switch (modalType) {
      case MODAL_TYPES.LOGIN:
        return <LoginModal onClose={closeModalWithRedirectClear} />;
      case MODAL_TYPES.SIGNUP:
        return <SignupModal onClose={closeModal} />;
      case MODAL_TYPES.FIND_EMAIL:
        return <FindEmailModal onClose={closeModal} />;
      case MODAL_TYPES.PASSWORD:
        return <PasswordModal onClose={closeModal} />;
      case MODAL_TYPES.RESET:
        return <ResetModal onClose={closeModal} />;
      default:
        return null;
    }
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 pb-20 md:px-0 md:pb-0"
      onClick={handleBackdropClose}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <Suspense fallback={null}>{renderModal()}</Suspense>
      </div>
    </div>,
    document.getElementById('root') as HTMLElement,
  );
};

export default Modals;
